import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeTourStep: 0,
};

export const appTourSlice = createSlice({
  name: "appTour",
  initialState,
  reducers: {
    updateActiveTourStep: (state, action) => {
      state.activeTourStep = action.payload;
    },
  },
});

export const { updateActiveTourStep } = appTourSlice.actions;

export default appTourSlice.reducer;
